import React, { FC, useState } from 'react';
import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { State } from 'moduleBase/types/State';
import { StateType } from 'moduleBase/modules/menu-balance/types/StateType';
import { REDUCER_MENU_BALANCE_NAME } from 'moduleBase/modules/menu-balance/constants';
import {
  MenuBalanceContext,
  MenuBalanceContextType,
} from 'moduleBase/modules/menu-balance/contexts/menu-balance-context';
import { MenuBalanceDropdown } from 'moduleBase/modules/menu-balance/components/MenuBalanceDropdown';

type PropTypes = StateType

const MenuBalance: FC<PropTypes> = ({
  menu,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!menu) {
    return null;
  }

  const hide = () => {
    setIsOpen(false);
  };

  const show = () => {
    setIsOpen(true);
  };

  const menuBalanceContextValue: MenuBalanceContextType = {
    isOpen,
    menu,
    show,
    hide,
  };

  return (
    <MenuBalanceContext.Provider value={menuBalanceContextValue}>
      <div className="col-auto d-none d-xl-block">
        <MenuBalanceDropdown />
      </div>
    </MenuBalanceContext.Provider>
  );
};

export default connect<StateType>(MenuBalance, {
  mapStateToProps: (state: State) => state[REDUCER_MENU_BALANCE_NAME],
});
